var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBell(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 75,
    height: 46,
    viewBox: "0 0 75 46",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.24335 37.7567C8.24335 37.7567 7.46293 8.10077 37.509 8.10077C67.5552 8.10077 66.7747 37.7567 66.7747 37.7567M30.8755 8.63948C30.8755 8.63948 30.8755 1.85742 37.1188 1.85742C43.3622 1.85742 43.3622 8.51425 43.3622 8.51425M48.8251 18.2462C53.5076 20.5875 58.1901 25.27 58.1901 32.2937M39.4601 15.1245C41.8013 15.1245 44.1426 15.905 45.7034 16.6854M5.12167 37.7567H69.8964C69.8964 37.7567 73.0181 37.7567 73.0181 40.8783C73.0181 44 69.8964 44 69.8964 44H5.12167C5.12167 44 2 44 2 40.8783C2 37.7567 5.12167 37.7567 5.12167 37.7567Z",
    stroke: "white",
    strokeWidth: 3
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBell);
export default __webpack_public_path__ + "static/media/bell.cea060e1.svg";
export { ForwardRef as ReactComponent };